// extracted by mini-css-extract-plugin
export default {"overlay":"Dz-z","bodyOpen":"Ez-z","content":"Fz-z","header":"Gz-z","close":"Hz-z","closeNoHeading":"Iz-z"};